module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_2.3e6ee247.png";